// @flow
import Resource from 'speed-js-core/src/api/NestedResource';

export default class PatrolResource extends Resource {
    basePath: string = 'services/providers/providers/{parent}/patrols/';

    objectPath: string = 'services/providers/providers/{parent}/patrols/{ident}/';
}
